import { useState, useEffect } from "react";
import { fetchWithAuth } from "./authHelpers";

export const usePack = () => {
    const [packs, setPacks] = useState([]);
    const [hasOpenedDailyPack, setHasOpenedDailyPack] = useState(false);
    const [dailyPackID, setDailyPackID] = useState(null);
    const [dailyPackRemainingTime, setDailyPackRemainingTime] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchPacks = async () => {
        try {
            setIsLoading(true);
            setError(null);
            // Fetch packs
            const packsResponse = await fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/packs/active`, 'GET');
            if (!packsResponse.ok) {
                throw new Error('Network response was not ok');
            }

            const packsData = await packsResponse.json();
            const sortedPacks = packsData.sort((a, b) => new Date(a.startDate) - new Date(b.startDate));
            setPacks(sortedPacks);

            // Fetch daily pack status
            const dailyStatusResponse = await fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/packs/daily/status`, 'GET');
            
            const dailyStatusData = await dailyStatusResponse.json();
            setHasOpenedDailyPack(dailyStatusData.hasOpened);
            setDailyPackID(dailyStatusData.packID);
            setDailyPackRemainingTime(dailyStatusData.remainingTime);
        } catch (error) {
            setIsLoading(false);
            setError("Failed to fetch packs");
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchPacks();
    }, []);

    return { packs, hasOpenedDailyPack, dailyPackID, dailyPackRemainingTime, isLoading, error };
};